import { createContext } from 'react';
import type { Venue, Profile, TeamMemberPermissions } from '../types';

export interface VenueContextType {
  venues: Venue[];
  activeVenue: Venue | null;
  profile: Profile | null;
  activeMemberRole: string | null;
  activeMemberPermissions: TeamMemberPermissions;
  organizationId: string | null;
  orgRole: string | null;
  authEmail: string | null;
  isEmailConfirmed: boolean | null;
  isLoading: boolean;
  setActiveVenue: (venue: Venue) => void;
  refreshVenues: () => Promise<void>;
}

export const VenueContext = createContext<VenueContextType | undefined>(undefined);
